function formatBackendTs(ts) {
    if (ts == null || ts === "") return "";
    const s = String(ts).replace(/\D/g, "");
    if (s.length >= 14) {
        return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)} ${s.slice(8, 10)}:${s.slice(10, 12)}:${s.slice(12, 14)}`;
    }
    if (s.length === 8) return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
    return String(ts);
}

export function mapMasterRowToProduct(row) {
    if (!row) return null;
    const en = row.enabled != null ? String(row.enabled).toUpperCase().charAt(0) : "Y";
    const ptName =
        row.defaultProdPtName ||
        row.defaultProdPointName ||
        row.defaultProdPointNm ||
        row.defaultProdPtNm ||
        row.prodPtNm ||
        row.prodPtName ||
        row.ptName ||
        "";
    const targetEi =
        row.targetEI != null && row.targetEI !== ""
            ? Number(row.targetEI)
            : row.targetEi != null && row.targetEi !== ""
              ? Number(row.targetEi)
              : null;
    return {
        product_id: row.productIdx,
        product_code: row.productCode,
        product_name: row.productName,
        product_unit: row.unitSmallCode || "EA",
        pt_addr: row.defaultProdPtAddr || "",
        pt_name: ptName,
        default_prod_pt_idx: row.defaultProdPtIdx != null ? row.defaultProdPtIdx : null,
        use_yn: en === "Y" ? "Y" : "N",
        remarks: row.remarks != null ? String(row.remarks) : "",
        target_ei: Number.isFinite(targetEi) ? targetEi : null,
        target_ei_unit: row.targetEiUnit != null ? String(row.targetEiUnit) : "",
        created_at: formatBackendTs(row.regDate),
        updated_at: formatBackendTs(row.modDate),
    };
}

export function buildInsertProductBody(form) {
    const body = {
        productCode: form.product_code,
        productName: form.product_name,
        unitSmallCode: form.product_unit || null,
        enabled: form.use_yn || "Y",
    };
    if (form.pt_addr) body.defaultProdPtAddr = form.pt_addr;
    if (form.default_prod_pt_idx != null && form.default_prod_pt_idx !== "") {
        body.defaultProdPtIdx = form.default_prod_pt_idx;
    }
    if (form.remarks != null && String(form.remarks).trim() !== "") {
        body.remarks = String(form.remarks).trim();
    }
    if (form.target_ei != null && form.target_ei !== "") {
        const n = Number(form.target_ei);
        if (Number.isFinite(n)) body.targetEI = n;
    }
    if (form.target_ei_unit != null && String(form.target_ei_unit).trim() !== "") {
        body.targetEiUnit = String(form.target_ei_unit).trim();
    }
    return body;
}

export function buildUpdateProductBody(form) {
    const targetEi =
        form.target_ei != null && form.target_ei !== ""
            ? Number(form.target_ei)
            : null;
    return {
        productIdx: form.product_id,
        productCode: form.product_code,
        productName: form.product_name,
        unitSmallCode: form.product_unit || null,
        defaultProdPtAddr: form.pt_addr != null ? form.pt_addr : "",
        defaultProdPtIdx: form.default_prod_pt_idx != null ? form.default_prod_pt_idx : null,
        enabled: form.use_yn || "Y",
        remarks: form.remarks != null ? String(form.remarks) : "",
        targetEI: Number.isFinite(targetEi) ? targetEi : null,
        targetEiUnit:
            form.target_ei_unit != null && String(form.target_ei_unit).trim() !== ""
                ? String(form.target_ei_unit).trim()
                : null,
    };
}
